(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["state-header"]) return;
  try {
    
   document.addEventListener("DOMContentLoaded", function() {
    var img = document.getElementById("dynamic-image");
    img.onload = function() {
      img.setAttribute("width", img.naturalWidth);
      img.setAttribute("height", img.naturalHeight);
    };
  });

  } catch(e) { console.error(e); }
})();
})();
